import cloneDeep from 'lodash.clonedeep';
import { OBJECTIVE_VISIBILITY_TYPES } from './constants';

const findRootDestinationIndex = parentPositionIndex => {
  if (typeof parentPositionIndex === 'number') return parentPositionIndex;
  return +parentPositionIndex.split('.')[0];
};

const getObjectiveByPositionIndex = (objectivesList, positionIndex) => {
  if (positionIndex !== 0 && !positionIndex) return null;
  const index = findRootDestinationIndex(positionIndex);
  let rootObjective = objectivesList[index];
  if (typeof positionIndex === 'string') {
    const position = positionIndex.split('.');
    /* Move to the actual parent of the objective in the tree */
    for (let j = 1; j < position.length; j++) {
      // going to the moved objective in the tree
      rootObjective = rootObjective?.key_results[position[j]];
    }
  }
  return rootObjective;
};

const findRootObjectiveIndex = (objectivesList, objective) =>
  objectivesList.findIndex(obj => obj.objective_id === objective.objective_id);

export default {
  revertObjectiveMoveAction: (objectivesList, undoActionData) => {
    const {
      objective_id,
      currentObjective,
      direction,
      parentPositionIndex,
      newParentPositionIndex,
      nextRootObjective,
      useCaseIdentifier,
      movedKrIndexInParentObj,
      isCompanyObjective
    } = undoActionData;
    const dataListClone = cloneDeep(objectivesList);
    let originalParentObj = null;
    const newParentObj = getObjectiveByPositionIndex(
      dataListClone,
      (useCaseIdentifier === 1 || useCaseIdentifier === 6) &&
        direction === 'down'
        ? typeof newParentPositionIndex === 'string'
          ? +newParentPositionIndex.charAt(0) -
            1 +
            newParentPositionIndex.substr(1)
          : newParentPositionIndex - 1
        : newParentPositionIndex
    );
    let currentIndex = 0;

    if (newParentObj) {
      if (newParentObj?.key_results.length > 0) {
        /* Find the index/position of the kr within it's parent's tree */
        for (
          currentIndex = 0;
          currentIndex < newParentObj?.key_results.length;
          currentIndex++
        ) {
          if (
            newParentObj?.key_results[currentIndex].objective_id ===
            objective_id
          )
            // find objective index in key results
            break;
        }
        newParentObj?.key_results?.splice(currentIndex, 1);
      }
      newParentObj.key_results_count -= 1;
    } else
      dataListClone.splice(
        findRootObjectiveIndex(dataListClone, currentObjective),
        1
      );
    switch (useCaseIdentifier) {
      case 0 /* Last root objective */:
        if (isCompanyObjective) currentObjective.version++;
        dataListClone.push(currentObjective);
        return dataListClone;
      case 1 /* Non-last root objective */:
        if (isCompanyObjective) currentObjective.version++;
        /* Find the index of the next root objective and insert the deleted obj before it */
        dataListClone.splice(
          nextRootObjective.positionIndex - 1,
          0,
          currentObjective
        );
        return dataListClone;
      case 2 /* Only KR */:
      case 3 /* Last KR */:
        originalParentObj = getObjectiveByPositionIndex(
          dataListClone,
          parentPositionIndex
        );
        originalParentObj.key_results.push(currentObjective);
        originalParentObj.key_results_count++;
        return dataListClone;
      case 4 /* KR in between */:
        originalParentObj = getObjectiveByPositionIndex(
          dataListClone,
          parentPositionIndex
        );
        originalParentObj.key_results.splice(
          movedKrIndexInParentObj,
          0,
          currentObjective
        );
        originalParentObj.key_results_count++;
        originalParentObj.kr_order_version++;
        return dataListClone;
      case 5 /* Last Aligned objective */:
        dataListClone.push(currentObjective);
        return dataListClone;
      case 6 /* Aligned objective in between */:
        dataListClone.splice(
          nextRootObjective.positionIndex - 1,
          0,
          currentObjective
        );
        return dataListClone;
      default:
        break;
    }
  }
};

export const isValidDrop = (objectivesList, dropActionData) => {
  const {
    source: { index: sourceIndex, positionIndex: sourcePositionIndex },
    destination: {
      isCombine,
      index: destinationIndex,
      positionIndex: destinationPositionIndex
    }
  } = dropActionData;

  if (
    sourceIndex === null ||
    (destinationIndex === null && destinationPositionIndex === null)
  )
    return true;
  const referenceObjective =
    (sourceIndex === 0 || !!sourceIndex) &&
    (destinationIndex === 0 || !!destinationIndex)
      ? destinationIndex > sourceIndex &&
        objectivesList[destinationIndex + 1]?.positionIndex.toString().length >
          objectivesList[destinationIndex].positionIndex.toString().length
        ? objectivesList[destinationIndex + 1]
        : objectivesList[destinationIndex]
      : null;
  const sourceObjective = sourcePositionIndex
    ? objectivesList.find(obj => obj.positionIndex === sourcePositionIndex)
    : null;
  if (
    sourceObjective &&
    [
      OBJECTIVE_VISIBILITY_TYPES.public,
      OBJECTIVE_VISIBILITY_TYPES.publicWithOKR
    ].indexOf(sourceObjective.privacy_details.type) === -1
  ) {
    if (isCombine) return false;
    if (referenceObjective?.parent_objective_id) return false;
    /* allow reorder for non public objectives */
    return true;
  }
  let parentObjective = null;
  if (!isCombine)
    parentObjective = referenceObjective
      ? objectivesList.find(
          obj => obj.objective_id === referenceObjective.parent_objective_id
        ) || null
      : null;
  else
    parentObjective = objectivesList.find(
      obj => obj.positionIndex === destinationPositionIndex
    );

  if (
    parentObjective &&
    [
      OBJECTIVE_VISIBILITY_TYPES.public,
      OBJECTIVE_VISIBILITY_TYPES.publicWithOKR
    ].indexOf(parentObjective.privacy_details.type) === -1
  )
    return false;
  return true;
};
